import axios from "axios";
const state = {
	total_investment: 0,
	leads: [],
	searchValue: ""
};

const getters = {
	StateLeads: (state) => state.leads,
	StateTotalInvestment: (state) => state.total_investment,
	StateFirstDate: (state) => state.first_date,
	StateLastDate: (state) => state.last_date,
};

const actions = {
	async getLeads({ commit }, params) {
		let siteId = this.getters.StateSiteSeleted,
			token = this.getters.StateToken,
			user = this.getters.StateUser,
			type = this.getters.StateTypeSelected,
			dates = params.dates,
			lead_id = params.lead_id;

		if (lead_id === null) lead_id = 0;

		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		let service = null;
		if (user.isSuperUser && siteId === -1) {
			service = `leads/admin_data/${user.id}/${dates.join("/")}`;
		} else if (typeof siteId === "number") {
			service = `leads/data/${siteId}/${dates.join("/")}`;
			service = service + "/" + lead_id + `/${type}`;
		}
		if (service !== null) {
			let response = await axios.get(service);
			await commit("setLeads", response.data.data.leads);
			await commit(
				"setTotalInvestment",
				response.data.data.total_investment
			);
			await commit("setShowTotalRev", response.data.data.showTotalRev);
			await commit("setShowFeesInv", response.data.data.showFeesInv);
			await commit("setShowOutbound", response.data.data.showOutbound);
			return true;
		} else return false;
	},
	async getleadById({ commit }, lead_id) {
		let token = this.getters.StateToken,
			service = null;

		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		service = `leads/data_id/${lead_id}`;
		let response = await axios.get(service);

		return response.data.data.lead;
	},
	async saveExtraLeads({ commit }, extrafields) {
		const token = this.getters.StateToken;
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		if (extrafields.get("save_history") === "true") {
			const user = this.getters.StateUser;
			extrafields.append("admin_id", user.id);
			extrafields.append("site_id", this.getters.StateSiteSeleted);
		}

		const response = await axios.post(`leads_extras/save`, extrafields),
			lead_extra_id = response.data.data.lead_extra_id;

		return lead_extra_id;
	},
	async getDataCharts({ commit }) {
		const siteId = this.getters.StateSiteSeleted,
			token = this.getters.StateToken,
			type = this.getters.StateTypeSelected,
			service = `leads/charts/${siteId}/${type}`;

		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const response = await axios.get(service);
		return response.data.data;
	},
	async deleteLead({ commit }, lead_id) {
		const token = this.getters.StateToken,
			user = this.getters.StateUser,
			data = new FormData();

		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		data.append("lead_id", lead_id);
		data.append("admin_id", user.id);
		const response = await axios.post(`leads/delete`, data);

		return response.data.data;
	},
};

const mutations = {
	setTotalInvestment(state, total_investment) {
		state.total_investment = total_investment;
	},
	setLeads(state, leads) {
		state.leads = leads;
	},
	setNewSearch( state, newSearch ){
        state.searchValue = state.searchValue == newSearch ? '' : newSearch;
    }
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/leads.js